export class FilterValueRange {
  Min?: number | Date | null;
  Max?: number | Date | null;

  constructor();
  constructor(min: number);
  constructor(min: Date);
  constructor(min: number, max: number);
  constructor(min: Date, max: Date);
  constructor(min?: number | Date | null, max?: number | Date | null) {
    this.Min = min;
    this.Max = max;
  }
}
